const PRODUCTSIZE_ACTION_TYPES = {
  LOAD_PRODUCTSIZE: 'user/LOAD_PRODUCTSIZE',
};

export default PRODUCTSIZE_ACTION_TYPES;
